import React, {useEffect, useState} from "react";
import NarrowHeading from "../../components/NarrowHeading";
import {Box, Form, FormField, Paragraph, TextInput} from "grommet";
import HiddenFormField from "../../components/HiddenFormField";
import {getCsrfToken} from "next-auth/react";
import {handleErrors} from "../../utils/errors";
import LoginPageLayout from "../../components/layouts/LoginPageLayout";
import Button from "../../components/Button";
import StatusMessage from "../../components/StatusMessage";

const PasswordReset = ({showNotification}) => {

    const [csrfToken, setCsrfToken] = useState('')
    const [resetRequested, setResetRequested] = useState(false)
    const [googleOAuthError, setGoogleOAuthError] = useState(false)

    useEffect(() => {
        getCsrfToken().then((token) => {
            setCsrfToken(token)
        })
    })

    const onSubmit = ({ value }) => {
        setGoogleOAuthError(false);
        fetch('/api/auth/password-reset', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(value),
        }).then(handleErrors)
            .then(showNotification)  //success case
            .then(() => {
                setResetRequested(true)
            })
            .catch((error) => {
                // Check for google_oauth_user error
                if (error?.error === 'google_oauth_user' || error?.message?.includes('google_oauth_user')) {
                    setGoogleOAuthError(true);
                } else {
                    showNotification(error);
                }
            })
    }

    return (
        <LoginPageLayout title="Forgot Password">
            <NarrowHeading heading="Reset your password"
                paragraph="To reset your password, please tell us the email associated with your account."/>
            <Box vertical={{pad: 'small'}}>
                {googleOAuthError && (
                    <Box margin={{ bottom: "medium" }}>
                        <StatusMessage
                            apiError={{
                                type: "info",
                                message: "This account uses Google Sign-In. Password reset is not available."
                            }}
                        />
                    </Box>
                )}
                {!resetRequested && !googleOAuthError && (
                    <Form
                        onSubmit={onSubmit}
                        messages={{
                            required: "This field is required"
                        }}
                    >
                        <Box margin={{"vertical": "xsmall"}}>
                            <HiddenFormField
                                name="csrfToken"
                                type="hidden"
                                value={csrfToken}
                            />
                            <FormField validate={{
                                regexp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: "Please enter a valid email address"
                            }}
                            required
                            component={TextInput}
                            placeholder="Email address"
                            name="email"
                            />
                            <Box margin={{"vertical": "medium"}}>
                                <Button
                                    event={{section: 'password_reset_form', element: 'submit'}}
                                    type="submit"
                                    primary
                                    label="Send reset email"
                                />
                            </Box>
                        </Box>
                    </Form>
                )}
                {resetRequested && (
                    <Box>
                        <Paragraph fill>
                            Please check your email for instructions on how to rest your password.
                        </Paragraph>
                    </Box>
                )}
            </Box>
        </LoginPageLayout>
    )
}

export default PasswordReset;

PasswordReset.auth = false;
